import { Locale } from '@/enums/enum/Locale';
import { useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export default function LanguageSwitcher({ onLocaleChange }: any) {
  const [locale, setLocale] = useState<Locale>(Locale.en);
  const { i18n } = useTranslation();

  useEffect(() => {
    setLocale(i18n.language === 'en' ? Locale.en : Locale.my);
  }, [i18n.language]);

  const handleLocaleChange = (locale: Locale) => {
    const lang = locale === Locale.en ? Locale.my : Locale.en;
    lang === Locale.en ? i18n.changeLanguage('en') : i18n.changeLanguage('my');
    setLocale(() => lang);

    if (onLocaleChange) {
      onLocaleChange(lang === Locale.en ? 'English' : 'Bahasa Malaysia');
    }
  };

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      {locale === Locale.en ? `Switch to Bahasa Malaysia` : `Switch to English`}
    </Tooltip>
  );

  return (
    <Wrapper>
      <OverlayTrigger
        placement="left"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip}
      >
        <i className="bi bi-globe" onClick={() => handleLocaleChange(locale)}>
          <Small>{locale.slice(0, 2).toLocaleUpperCase()}</Small>
        </i>
      </OverlayTrigger>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-left: 2rem;
  margin-right: 1rem;
  color: #4a5568;
  font-size: 16px;
  cursor: pointer;
  display: inline;

  @media (max-width: 767px) {
    display: block;
    margin-bottom: 0.5rem; /* Add margin for separation on small screens */
  }
`;

const Small = styled.small`
  font-size: 14px;
`;
